// ============== КНОПКА "Next" ======================

import { notify } from '../../toastify/toastify';
import { tripData } from './trip-form.js';

import { renderTripsInfo } from '../step2/utils/renderAdressInfo.js';
import { renderPriceInfo } from '../step2/utils/renderPriceInfo.js';
import { changeBorderColor } from './utils/changeInputsStyled.js';

const ONE_HOUR_MS = 60 * 60 * 1000;

// =====================================
// Селектори
// =====================================
const refs = {
  buttonToCars: document.querySelector('[data-next-to-cars]'),
  form: document.querySelector('form'),
  sectionContacts: document.getElementById('map-form'),
  sectionCars: document.querySelector('.cars'),
};
const { buttonToCars, form, sectionContacts, sectionCars } = refs;

// =====================================
// Слухач кнопки "Next"
// =====================================
// Ініціалізуємо слухач лише якщо елементи присутні на сторінці
if (buttonToCars && form && sectionContacts && sectionCars) {
  // Always intercept click to open passengers modal; proceed only after modal confirms
  buttonToCars.addEventListener('click', handlerOpenPassengersModal);
  // When modal confirms, proceed to cars section
  window.addEventListener('passengersModal:confirmed', () => {
    proceedToCars();
  });
}

function handlerOpenPassengersModal(e) {
  e.preventDefault();

  // 1. Спочатку валідація
  if (!isStep1Valid()) return;

  // 2. Лише якщо крок пройдено успішно – шлемо конверсію
  if (typeof gtag === 'function') {
    gtag('event', 'conversion', {
      send_to: 'AW-17689061394/3_hyCPzDlsEbEJLQ5vJB',
    });
  }

  // 3. Відкриваємо модал з пасажирами
  import('./passengersModal.js').then(mod => {
    mod.openPassengersModal();
  });
}

// =====================================
// Валідація першого кроку перед відкриттям модалки
// =====================================
function isStep1Valid() {
  if (!form) return false;
  // Перевіряємо всі required інпути
  const requiredInputs = form.querySelectorAll('.form-input[required]');
  let allFilled = true;
  requiredInputs.forEach(inp => {
    if (!inp.value.trim()) {
      allFilled = false;
      changeBorderColor(inp, '2px solid #ef9d5b');
    }
  });

  // окремо перевіримо адреси з tripData (щоб були не порожні та вибрані)
  const pickupInput = form.querySelector('#get-in');
  const dropoffInput = form.querySelector('#get-out');
  if (!tripData.from || !tripData.from.address) {
    allFilled = false;
    notify('select_fromAdress', 'error');
    if (pickupInput) changeBorderColor(pickupInput, '2px solid #ef9d5b');
  }
  if (!tripData.to || !tripData.to.address) {
    allFilled = false;
    notify('select_toAdress', 'error');
    if (dropoffInput) changeBorderColor(dropoffInput, '2px solid #ef9d5b');
  }

  // Якщо вибрано зворотну поїздку - час також має бути заповнений
  const returnTripCheckbox = document.getElementById('return-trip');
  const returnTripTimeInput = document.getElementById('return-trip_time');
  if (returnTripCheckbox?.checked) {
    if (!returnTripTimeInput?.value.trim()) {
      allFilled = false;
      notify('return_trip_time_required', 'error');
      if (returnTripTimeInput)
        changeBorderColor(returnTripTimeInput, '2px solid #ef9d5b');
    }
  }

  if (!allFilled) {
    // загальна помилка якщо щось порожнє
    notify('form_complete', 'error');
  }

  // ====== Flight number presence (if field is visible) ======
  const flightWrapper = document.getElementById('flightNumberWrapper');
  const flightField = document.getElementById('flightNumberField');

  if (flightWrapper && flightField && flightWrapper.style.display !== 'none') {
    const raw = flightField.value;
    if (!raw.trim()) {
      allFilled = false;
      changeBorderColor(flightField, '2px solid #ef9d5b');
      notify('flight_number_required', 'error'); // i18n key should exist; if not add it.
    }
  }

  // ====== Мінімум за годину до поїздки ======
  const tripTimeInput = document.getElementById('time');
  const minAllowed = getMinAllowedDate();
  if (tripTimeInput && !isDateAtLeast(tripTimeInput.value, minAllowed)) {
    allFilled = false;
    changeBorderColor(tripTimeInput, '2px solid #ef9d5b');
    notify('trip_time_min_one_hour', 'error');
  }
  if (returnTripCheckbox?.checked && returnTripTimeInput) {
    if (!isDateAtLeast(returnTripTimeInput.value, minAllowed)) {
      allFilled = false;
      changeBorderColor(returnTripTimeInput, '2px solid #ef9d5b');
      notify('trip_time_min_one_hour', 'error');
    }
  }

  return allFilled;
}

function proceedToCars() {
  if (!isStep1Valid()) return;

  renderPriceInfo();
  renderTripsInfo();

  sectionContacts.style.display = 'none';
  sectionCars.style.display = 'flex';
  sectionCars.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

function getMinAllowedDate() {
  const min = new Date(Date.now() + ONE_HOUR_MS);
  min.setSeconds(0, 0);
  return min;
}

function isDateAtLeast(rawValue, minDate) {
  if (!rawValue) return false;
  const parsed = new Date(rawValue.replace(' ', 'T'));
  if (Number.isNaN(parsed.getTime())) return false;
  return parsed.getTime() >= minDate.getTime();
}
